export default __webpack_public_path__ + "static/future-proof-87ae4726d3af9ff4d178b08b493b0420.jpg";